import { IntegratedRecordsList } from 'components/IntegratedRecordsList';
import React from 'react';
import { connect } from 'react-redux';
import { ApplicationState, RateRecord } from 'types';
import { RecordsHandler } from './RecordsHandler';
import { ViewTile } from './viewTile';

let CSS = `
#selection-dropdown {
    display: none !important;
}
.tile.amar-rates-record.detail {
    padding-top: 15px;
}

.tile.amar-rates-record .main-details {
    padding-right: 30px;
}

.tile.amar-rates-record .main-details .title {
	text-align: right;
	padding: 0;
	margin-bottom: 15px;
    font-weight: bold;
    font-size: 0.9em;
}

.tile.amar-rates-record .main-details .value {
	padding-right: 0;
	margin-bottom: 15px;
}

.tile.amar-rates-record input {
	width: 100%;
	background-color: white!important;
    border: none;
    border-bottom: 1px solid darkgray;
}

	
.tile.amar-rates-record input:disabled {
	background-color: #CCC!important;
}

.tile.amar-rates-record input:focus {
    outline: none;    
}

.tile.amar-rates-record .value select {
	width: 100%;
}

div.tile.amar-rates-record .main-details .value {
    border-bottom: 1px solid lightgrey;
    min-height: 1.5em;
    padding-right: 0;
}
`;

const html = `
<style>
	${CSS}
</style>

<div id="page-records">
    <div class="records">
        <div class="filtered-records">
        </div>
    </div>
</div>
`;

interface Props {
	records: RateRecord[];
}

class Component extends React.Component<Props> {
	render() {
		return (
			<React.Fragment>
				<IntegratedRecordsList
					records={this.props.records}
					RecordTile={ViewTile}
					html={html}
					RecordsHandler={RecordsHandler}
				/>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state: ApplicationState) {
	return {
		records: state.dataState.rate.filtered,
	};
}

export const Rate = connect(mapStateToProps)(Component);
